import { render, staticRenderFns } from "./lightHeader.vue?vue&type=template&id=0ebd294e&scoped=true&"
import script from "./lightHeader.vue?vue&type=script&lang=js&"
export * from "./lightHeader.vue?vue&type=script&lang=js&"
import style0 from "./lightHeader.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./lightHeader.vue?vue&type=style&index=1&id=0ebd294e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebd294e",
  null
  
)

export default component.exports